import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, InputValuesStatusDto, ErrorLevel, ILineChartData, TagDateValue } from '../../models';
import { IwidgetIntervalHelperService, IAlarmService, IDateRangeService } from '../../services/';
import { refreshClick, WideError } from '../../common/';

class AlarmsGaugesController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    statuses: InputValuesStatusDto[];
    error: WideError;

    readonly boundData: TagDateValue[];
    readonly clicked: ILineChartData;

    private _error: WideError;

    static $inject = [
        '$scope',
        'dateRangeService',
        'widgetIntervalHelperService',
        'alarmService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _dateRangeService: IDateRangeService,
        private _widgetIntervalHelperService: IwidgetIntervalHelperService,
        private _alarmsService: IAlarmService
    ) {
    }

    $onInit() {
        this.refreshData(true);
        this._$scope.$on(refreshClick, () => {
            this.refreshData();
        });
    }

    private refreshData(force?: boolean) {
        if (this._dateRangeService.initialized()) {
            const defaultInterval = this._widgetIntervalHelperService.getCurrentInclusiveInterval();
            const beginDate = defaultInterval.beginDate;
            const endDate = defaultInterval.endDate;
            this.isLoading = true;
            return this._alarmsService
                .getPercentageBetweenDates(beginDate, endDate, force)
                .then(data => {
                    const sortBy = _.sortBy(data, d => d.statusId);
                    return this.getStatuses(sortBy);
                })
                .then(data => this.statuses = data)
                .finally(() => this.isLoading = false);
        }
    }

    private getStatuses(value?: InputValuesStatusDto[]): InputValuesStatusDto[] {
        if (arguments.length) {
            this._error = _.some(value, v => v.statusId === 6 && v.percentage > 0)
                ? new WideError(ErrorLevel.Error, 'Critical alarms')
                : _.some(value, v => v.statusId === 7 && v.percentage > 0)
                    ? new WideError(ErrorLevel.Warning, 'Warning alarms')
                    : _.some(value, v => v.statusId === 8 && v.percentage > 0)
                        ? new WideError(ErrorLevel.Info, 'Information alarms')
                        : null;
            this.error = this._error;
        }
        return value;
    }

    getError(): WideError {
        return this._error;
    }

    getErrorBetweenDates(beginDate: string, endDate: string): angular.IPromise<WideError> {
        return this._alarmsService
            .getPercentageBetweenDates(beginDate, endDate)
            .then(() => {
                return this._error;
            });
    }
}

export const wtAlarmsGauges: ComponentDefinition = {
    componentId: 'wtAlarmsGauges',
    controller: AlarmsGaugesController,
    template: require('./alarmsGauges.component.html'),
    controllerAs: 'vm',
    bindings: {
        boundData: '=?',
        clicked: '=?',
        error: '=?'
    }
};
